import { render, staticRenderFns } from "./ListTable.vue?vue&type=template&id=b1d586f2&scoped=true&"
import script from "./ListTable.vue?vue&type=script&lang=js&"
export * from "./ListTable.vue?vue&type=script&lang=js&"
import style0 from "./ListTable.vue?vue&type=style&index=0&id=b1d586f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d586f2",
  null
  
)

export default component.exports